<template>
    <div class="rounded">
        <div class="pt-0 mb-0">
            <div class="add_license d-flex justify-content-between align-items-center flex-wrap mb-3 px-3">
                <h3 class="font-weight-bold f-18 text-left mb-0 text-black">{{ $t('activityFeed.title') }}</h3>
            </div>
            <div class="px-3">
                <div v-if="items.length === 0"
                    class="text-center text-muted py-4 bg-white rounded activity-card-empty">
                    {{ $t('activityFeed.noActivity') }}
                </div>
                <div class="activity-cards-list">
                    <div v-for="(item, idx) in items" :key="idx" class="activity-card">
                        <div class="activity-card-top">
                            <span class="activity-card-title">{{ item.actor_name || '-' }}</span>
                            <span class="activity-card-date">{{ item.action_time }}</span>
                        </div>
                        <div class="activity-card-divider"></div>
                        <p class="activity-card-body text-pre-line mb-0">{{ item.remarks }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import * as moment from "moment-timezone";
export default {
    name: "ActivityLogs",
    props: ['record', 'object_id'],
    data() {
        return {
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            fields: [
                {
                    key: "action_time",
                    label: "Date/Time",
                    sortable: true,
                    thClass: 'font-table-weight-bold',
                    stickyColumn: true,
                },
                {
                    key: "actor_name",
                    label: "User",
                    sortable: true,
                    thClass: 'font-table-weight-bold',
                },
                {
                    key: "remarks",
                    label: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ],
            items: [],
            isBusy: false,
            currentPage: 1,
            sortBy: undefined,
            sortDesc: undefined,
            emptyTable: false,
        }
    },
    watch: {
        sortBy: {
            async handler() {
                await this.getLogsData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getLogsData();
            },
        },
    },
    methods: {
        ...mapActions(['getModelActivityLogs']),
        async getLogsData() {
            try {
                this.items = []
                this.isBusy = true
                let url = ""
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=actor_name&sort_order=asc&`
                }
                url += `record=${this.record}&object_id=${this.object_id}`
                const data = await this.getModelActivityLogs(url);
                data.map((item) => {
                    this.items.push({
                        action_time: item.action_time ? moment.tz(item.action_time, this.userTimeZone).format("ll HH:mm") : '-',
                        actor_name: item.actor_name ? item.actor_name : '-',
                        remarks: item.remarks ? item.remarks : '-'
                    })
                })
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
            }
            catch (e) {
                this.isBusy = false
                console.log(e)
            }
        }
    },
    mounted() {
        this.getLogsData()
    },
}
</script>
<style>
.activity-log-search-field {
    width: 335px;
}

.activity-log-search-field>div {
    padding: 0px !important;
}

.activity-cards-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.activity-card {
    background: #FFFFFF;
    border: 1px solid #E2E6F0;
    border-radius: 8px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.activity-card-empty {
    border: 1px solid #E2E6F0;
}

.activity-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
}

.activity-card-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.5px;
    color: #222736;
    word-break: break-word;
    text-align: left;
    flex: 1 1 auto;
    min-width: 0;
}

.activity-card-date {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: black;
    white-space: nowrap;
}

.activity-card-divider {
    height: 1px;
    width: 100%;
    background: #E2E6F0;
}

.activity-card-body {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.32px;
    color: #222736;
    word-break: break-word;
    text-align: left;
}
</style>